import {trash} from "@/store/resources";
import {camelToKebab} from "@/utilities/helpers";


export default {
    namespaced: true,
    state: {
        trashSummary: null,
        trashList: {
            data: [],
            dirty: false,
            pagination: {
                current_page: 1,
                pages: null
            }
        }
    },
    actions: {
        async fetchSummary({commit, rootState}) {
            try {
                const space_id = rootState.space.current_space.data.id;
                const res = await trash.fetchSummary.get({space_id});
                if (res.body.success) {
                    commit('storeTrashSummary', res.body.data)
                }
            } catch (err) {
                console.log(err)
            }
        },
        async fetchTrashItems({commit, rootState}, trashModel) {
            try {
                commit('setTrashPageFirst')
                commit('setTrashListDirty')
                const space_id = rootState.space.current_space.data.id;
                const trashItem = camelToKebab(trashModel);
                const res = await trash.trashList.get({trashItem, space_id}, {});
                if (res.body.success) {
                    commit('storeTrashList', res.body);
                } else {
                    console.log(res)
                }
            } catch (err) {
                console.log(err)
            }
        },
        async fetchTrashItemsMore({state, commit, rootState}, trashItem) {
            try {
                const space_id = rootState.space.current_space.data.id;
                const res = await trash.trashList.get({
                    trashItem,
                    space_id,
                    page: state.trashList.pagination.current_page
                });
                if (res.body.success) {
                    commit('pushTrashList', res.body);
                } else {
                    console.log(res)
                }
            } catch (err) {
                console.log(err)
            }
        },
        restoreItem({}, {id, modelType}) {
            let types = {
                transactions: 'transaction',
                accounts: 'account',
                expenseCategories: 'expenseCategory',
                incomeSources: 'incomeSource',
                contractors: 'contractor',
            };
            let model = types[modelType];
            return trash.restoreTrashItem.save({id, model});
        }
    },
    mutations: {
        storeTrashSummary(state, data) {
            state.trashSummary = data;
        },
        setTrashListDirty(state) {
            state.trashList.dirty = true;
        },
        setTrashPageFirst(state) {
            state.trashList.pagination.current_page = 1;
        },
        storeTrashList(state, body) {
            state.trashList.data = body.data.rows;
            state.trashList.pagination.pages = Math.ceil(body.data.length / 20);
            state.trashList.dirty = false;
        },
        pushTrashList(state, body) {
            state.trashList.data.push(...body.data.rows)
        },
        setTrashListPage(state, num) {
            state.trashList.pagination.current_page = num;
        }
    }
}